import state from './adhoc.state'
import mutations from './adhoc.mutations'
import actions from './adhoc.actions'

export default {
  state,
  mutations,
  actions
}
